import { render, staticRenderFns } from "./RecordingsList.vue?vue&type=template&id=ed8f4c66&scoped=true&"
import script from "./RecordingsList.vue?vue&type=script&lang=js&"
export * from "./RecordingsList.vue?vue&type=script&lang=js&"
import style0 from "./RecordingsList.vue?vue&type=style&index=0&id=ed8f4c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8f4c66",
  null
  
)

export default component.exports